import baseReducer from 'redux/baseReducer';
import { fromJS, List, Map } from 'immutable';
import Types from './types';

export const initialState = fromJS({
    activeReport: Map({}),
    isError: false,
    isLoading: false,
    reports: List([]),
    selectedProducts: List([]),
});

const updateReportList = (state, { payload }) =>
    state.withMutations((r) => {
        r.set('reports', fromJS(payload))
            .set('isLoading', false);
    });

const updateReport = (state, { payload }) =>
    state.withMutations((r) => {
        r.set('activeReport', fromJS(payload))
            .set('isLoading', false);
    });

const setLoader = (state) => state.withMutations((r) => r.set('isLoading', true));

const deleteReport = (state, { payload }) => {
    const updReports = state.get('reports').filter((r) => r.get('id') !== payload);

    return state.withMutations((r) => r.set('reports', updReports));
};

export default baseReducer(initialState, {
    [Types.DELETE_REPORT]: deleteReport,
    [Types.SET_LOADER]: setLoader,
    [Types.UPDATE_REPORT]: updateReport,
    [Types.UPDATE_REPORT_LIST]: updateReportList,
});
